// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectPriceLimitsMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PRICE_LIMITS_MESSAGE);
        this.TradableId = null;
        this.HighLimit = null;
        this.LowLimit = null;
    }
}
